import {
    SITE_SET_ACTIVE
} from '../../action-types';

const initialState = {
    items: [
        {
            id: 3,
            name: 'A Day of Rest',
            url: 'https://adayofrest.hm/boston-2017',
            timezone: 'America/New_York'
        },
        {
            id: 2,
            name: 'Caldera WP',
            url: 'https://calderawp.com',
            timezone: 'America/New_York'
        },
        {
            id: 0,
            name: 'Post Status',
            url: 'https://poststatus.com',
            timezone: 'America/Winnipeg'
        },
        {
            id: 1,
            name: 'WP Shout',
            url: 'https://www.wpshout.com',
            timezone: 'America/Denver'
        }
    ],
    activeSite: {}
};


export default function sites( state = initialState, action ) {

    switch( action.type ) {

        case SITE_SET_ACTIVE:
            return Object.assign({}, state, {
                activeSite: action.site
            });

        default:
            return state;

    }

}


/** WEBPACK FOOTER **
 ** ./src/state/reducers/sites/index.js
 **/